import { PipeModule } from 'src/app/shared/pipe/pipe.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {LoadingComponent} from './loading.component';
import { LoadingCircleModule } from 'src/app/shared/component/common/loading-circle/loading-circle.module';

@NgModule({
  declarations: [LoadingComponent],
  exports: [LoadingComponent],
  imports: [
    LoadingCircleModule
  ]
})
export class LoadingModule { }
